import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const navigate = useNavigate();

    // Initialize from localStorage
    const [token, setToken] = useState(() => localStorage.getItem('token'));
    const [role, setRole] = useState(() => localStorage.getItem('role'));
    const [user, setUser] = useState(() => {
        const raw = localStorage.getItem('user');
        return raw ? JSON.parse(raw) : null;
    });

    // CENTRALIZED login() to set storage + state
    function login(newToken, newRole, newUser) {
        localStorage.setItem('token', newToken);
        localStorage.setItem('role', newRole);
        localStorage.setItem('user', JSON.stringify(newUser));
        setToken(newToken);
        setRole(newRole);
        setUser(newUser);
    }

    // CENTRALIZED logout() to clear storage + state + redirect
    function logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('user');
        setToken(null);
        setRole(null);
        setUser(null);
        navigate('/login');
    }

    // Fancy shmancy watch other tabs for logout
    useEffect(() => {
        function onStorage(evt) {
            if (evt.key === 'token' && evt.newValue === null) {
                logout();
            }
        }
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    return (
        <AuthContext.Provider value={{ token, role, user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

// Hook for easy access
export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be inside <AuthProvider>');
    return ctx;
}
